import { Spinner } from "@nextui-org/react";

export const LoadingIcon = () => (
    <div className="flex size-full min-h-60 items-center justify-center ">
        <Spinner
            classNames={{
                wrapper: "!size-20 sm:!size-24 lg:!size-28",
                circle1: "border-b-primaryBg border-b-4",
                circle2: "border-b-primaryBg border-b-4",
                label: "text-primaryText",
            }}
        />
    </div>
)